import React, { Component } from 'react';
import AuthFunctions from '../services/AuthService';
import Session from './Session';
import { Container, Row, Col, Button, Input } from 'reactstrap';
import { FaEye } from 'react-icons/fa';
import { NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';

export class Login extends Component {
    static displayName = Login.name;

    constructor(props) {
        super(props);

        this.state = {
            passwordType: 'password',
            loggingIn: false,
            username: '',
            password: '',
            usernameRequired: false,
            passwordRequired: false,
            signinFailed: false,
        };

        this.checkAuthenticated();
    }
    async checkAuthenticated() {
        var isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
        if (isAuthenticated) {
            window.location.href = '/';
            //this.props.history.push('/');
        }
    }

    async componentDidMount() {
        document.getElementsByTagName('html')[0].className = "background-login";
    }

    validateInfo = () => {
        var username = this.state.username;
        var password = this.state.password;
        var usernameMissing = false;
        var passwordMissing = false;

        if (username.trim().length === 0) {
            usernameMissing = true;
        }

        if (password.trim().length === 0) {
            passwordMissing = true;
        }

        this.setState({ usernameMissing: usernameMissing, passwordMissing: passwordMissing, loggingIn: false, signinFailed: false });

        return !usernameMissing && !passwordMissing;
    }

    handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            if (this.validateInfo()) {
                this.submitLogin();
            }
        }
    }

    TextWithLineBreaks = (text) => {
        const newText = text.split('\n').map((str, index) => (
            <span key={index}>
                {str}
                <br />
            </span>
        ));

        return (<div>{newText}</div>);
    }

    async submitLogin() {
        this.setState({ loggingIn: true });

        if (this.validateInfo()) {
            const tokenData = await AuthFunctions.signInAsync(this.state.username, this.state.password);

            this.setState({ loggingIn: false });

            // If token missing -> fail
            if (!tokenData || !tokenData.token || tokenData.token.length === 0) {

                let msg = 'Invalid username or password, please try again.';

                // New API error contract
                if (tokenData?.message) {
                    msg = tokenData.message;
                }
                // Legacy contract
                else if (tokenData?.errorMessage) {
                    msg = tokenData.errorMessage;
                }

                this.setState({
                    signinFailed: true,
                    errorMessage: msg
                });

                return;
            }

            // Successful login boundary:
            // UI owns the auth flow here.
            // - Persist JWT via Session (single source of truth for token storage)
            // - Then navigate.
            // AuthService must NOT store tokens or redirect.
            this.setState({ signinFailed: false, errorMessage: '' });
            Session.setUserSession(tokenData.userName, tokenData.token, tokenData.userId, tokenData.userRoles);
            window.location.href = '/';
        } else {
            this.setState({ loggingIn: false });
        }
    }

    render() {

        document.title = "Login - QDraw, Inc.";

        const logo = {
            width: '100%',
            display: 'block',
            margin: '0 auto'
        }

        return (
            <div className='main' style={{ marginTop: '20px' }}>
                <Container>
                    <Row className="row text-center" style={{ justifyContent: "center" }}>
                        <div className="login-content">
                            <img src="logo.jpg" alt="logo" style={logo} />
                            <section style={{ margin: '20px' }}>
                                {this.state.signinFailed &&
                                    <div className="form-group">
                                        <span style={{ color: 'red' }}>{this.TextWithLineBreaks(this.state.errorMessage)}</span>
                                    </div>
                                }
                                <div className="form-group">
                                    <Input
                                        type='text'
                                        onChange={(e) => this.setState({ username: e.target.value, usernameMissing: false })}
                                        className='form-control'
                                        value={this.state.username}
                                        onKeyPress={(e) => this.handleKeyPress(e)}
                                        placeholder='Username'
                                    />
                                    {this.state.usernameMissing &&
                                        <span style={{ color: 'red' }}>Username is required!</span>
                                    }
                                    <span asp-validation-for="Input.Email" className="text-danger"></span>
                                </div>
                                <div className="form-group">
                                    <Input
                                        type={this.state.passwordType}
                                        onChange={(e) => this.setState({ password: e.target.value, passwordMissing: false })}
                                        className='form-control'
                                        value={this.state.password}
                                        onKeyPress={(e) => this.handleKeyPress(e)}
                                        placeholder='Password'
                                    />
                                    <FaEye className="password-eye"
                                        style={{ marginRight: '15px', cursor: 'pointer', float: 'right', marginTop: '-25px' }}
                                        onClick={() => {
                                            var type = this.state.passwordType === 'password' ? 'text' : 'password';
                                            this.setState({ passwordType: type });
                                        }}
                                    />
                                    {this.state.passwordMissing &&
                                        <span style={{ color: 'red' }}>Password is required!</span>
                                    }
                                    <span asp-validation-for="Input.Password" className="text-danger"></span>
                                </div>
                                <Row>
                                    <Col style={{ textAlign: 'center' }}>
                                        <Button className='standardButton btn btn-primary' disabled={this.state.loggingIn} style={{ width: '100px' }} onClick={() => {
                                            this.submitLogin();
                                        }}>
                                            Log In
                                        </Button>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <p className="pull-left">
                                            <NavLink tag={Link} className="forgot-link" to={'/forgotpassword'}>Forgot your password?</NavLink>
                                        </p>
                                    </Col>
                                </Row>
                            </section>
                        </div>
                    </Row>
                </Container>
            </div>
        );
    }
}

